
import React from 'react';
import AdminRoute from '@/components/AdminRoute';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AdminHeader from '@/components/admin/AdminHeader';
import { useIsMobile } from '@/hooks/use-mobile';
import CustomerTabContent from '@/components/admin/tabs/CustomerTabContent';
import FeaturedTracksManager from '@/components/admin/FeaturedTracksManager';
import AdminUsersTabContent from '@/components/admin/tabs/AdminUsersTabContent';

const Admin: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <AdminRoute>
      <div className="container py-6 px-4 md:py-10 md:px-6">
        <AdminHeader isMobile={isMobile} />
        
        <Tabs defaultValue="customers" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="customers">Customers</TabsTrigger>
            <TabsTrigger value="featured">Featured Tracks</TabsTrigger>
            <TabsTrigger value="admins">Manage Admins</TabsTrigger>
          </TabsList>
          
          <TabsContent value="customers">
            <CustomerTabContent />
          </TabsContent>
          
          <TabsContent value="featured">
            <FeaturedTracksManager />
          </TabsContent>
          
          <TabsContent value="admins">
            <AdminUsersTabContent />
          </TabsContent>
        </Tabs>
      </div>
    </AdminRoute>
  );
};

export default Admin;
